import { createContext } from "react";

import { LicenseType } from "@/types/license.types";

export const LicenseTypeContext = createContext<LicenseType>("license");
